import Label from './Label';
import labelStyles from './label.module.scss';

export { Label, labelStyles };

export default Label;
